import { type IssueTypeField } from '../prepareSendIssueFields';
import { type JiraFieldMappersKeys } from './MapperInterface';

export interface TemplateMappingSchemaV1 {
  [jiraFieldKey: string]: string;
}

export enum IssueFieldSource {
  Axe = 'AxeIssue',
  FixedValue = 'fixed_value'
}

export type MappingDefinition = {
  sourceType: IssueFieldSource; // enumerable list of where to source this value
  source: string; // which field should we source the value
  mapperId: JiraFieldMappersKeys; // which mapper we should use to format the value
};

export type TemplateMappingSchemaV2 = {
  // new field to indicate version. We should also check that the next field also exists and is equal to true. We will use 2 fields to avoid a situation where an unversioned variant of the schema will look like a versioned one.
  dmversion: number;
  dmversioned: boolean;
  mapping: {
    [jiraFieldKey: string]: MappingDefinition;
  };
  fields: IssueTypeField[];
};
